import React, { useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { SortDirection } from '@Pages/RetroSynthesis/constants';
import Button from '@Components/Button';

import './RsTableHeaderSortControl.theme.scss';

const getClasses = (state, enabled, controlRule) =>
  cn({
    'rs-table-sort-control__icon': true,
    selected: state === controlRule,
    hidden: !enabled,
  });
export function RsTableSortControlPure({ children, state, onChange, enabled }) {
  const getControlClickHandler = useCallback(
    (controlRule) => () => {
      if (state !== controlRule) {
        onChange(controlRule);
      }
    },
    [state, onChange]
  );

  return (
    <div className="rs-table-sort-control">
      <div className="rs-table-sort-control__children">{children}</div>
      <div className="rs-table-sort-control__sort">
        <Button
          onClick={getControlClickHandler(SortDirection.DESC)}
          buttonConfig={{
            type: 'link',
            className: getClasses(state, enabled, SortDirection.DESC),
            size: 'xs',
            e2eName: `sort-button-desc-${children}`,
            ariaLabel: `Sort rows by ${children} in ${SortDirection.DESC.toLowerCase()}ending order.`,
            iconOnly: true,
          }}
          iconConfig={{ name: 'chevron-down', size: 'xs' }}
        />
        <Button
          onClick={getControlClickHandler(SortDirection.ASC)}
          buttonConfig={{
            type: 'link',
            className: getClasses(state, enabled, SortDirection.ASC),
            size: 'xs',
            e2eName: `sort-button-asc-${children}`,
            ariaLabel: `Sort rows by ${children} in ${SortDirection.ASC.toLowerCase()}ending order.`,
            iconOnly: true,
          }}
          iconConfig={{ name: 'chevron-up', size: 'xs' }}
        />
      </div>
    </div>
  );
}

RsTableSortControlPure.defaultProps = {
  enabled: true,
  onChange: () => null,
};

RsTableSortControlPure.propTypes = {
  children: PropTypes.node,
  enabled: PropTypes.bool,
  state: PropTypes.string,
  onChange: PropTypes.func,
};

const findSortState = (array, sortProperty) => {
  if (!array) {
    return;
  }
  const { direction } = array.find((item) => item && item.property === sortProperty) || {};

  // eslint-disable-next-line consistent-return
  return direction;
};

// Wrapper around original SortControl to reduce some copy/paste
function RsTableHeaderSortControl({ sortList, sortParam, onChange, children, enabled }) {
  return (
    <RsTableSortControlPure
      state={findSortState(sortList, sortParam)}
      onChange={(newValue) => onChange({ sort: `${sortParam},${newValue}` })}
      enabled={enabled}>
      {children}
    </RsTableSortControlPure>
  );
}

RsTableHeaderSortControl.defaultProps = {
  onChange: () => null,
};

RsTableHeaderSortControl.propTypes = {
  sortList: PropTypes.arrayOf(
    PropTypes.shape({
      property: PropTypes.string,
      direction: PropTypes.oneOf(SortDirection.allTypes),
    })
  ),
  sortParam: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node,
  enabled: PropTypes.bool,
};

export default RsTableHeaderSortControl;
